<script>
import PopupViewerMixins from './mixins/PopupViewerMixins'

export default {
  name: 'PopupViewerAlert',
  mixins: [PopupViewerMixins],
  created () {
    this.$nextTick(() => {
      this.show = true
    })
  }
}
</script>

<template>
  <transition name="fade">
    <div class="popup-viewer-mask" v-if="show" @click="handleClickOutside">
      <div class="popup-viewer-wrapper">
        <div class="popup-viewer-alert-container" :class="{ 'popup-viewer-shake': isClickingOutside }">
          <div class="popup-viewer-alert-header">{{ title }}</div>
          <div class="popup-viewer-alert-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
@import "assets/popup-viewer.css";
.popup-viewer-alert-container {
  position: absolute;
  background: white;
  width: 500px;
  margin: 0 auto;
  box-shadow: 0 1px 8px rgba(0, 0, 0, .53);
  border-radius: 7px;
  z-index: 10;
  color: #58666e
}
.popup-viewer-alert-header {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #dedede;
  height: 20px;
  font-size: small;
  color: inherit;
}

.popup-viewer-alert-body {
  font-size: small;
  margin: 20px 0;
  overflow: auto;
  position: relative;
  max-height: 85vh;
  padding: 10px 20px 5px 20px;
}

.fade-enter-active, .fade-leave-active {
  transition: all .3s ease;
}
.fade-enter {
  transform: scale(1.1);
  opacity: 0;
}
.fade-leave-to {
  transform: scale(.8);
  opacity: 0;
}
.fade-enter-to {
  opacity: 1
}
</style>



// WEBPACK FOOTER //
// PopupViewerAlert.vue?6f5c1c98